import React, { useState } from 'react';
import styled from 'styled-components';

const SelectDropDown = styled.div`
                    .select-box{
                        height:38px;
                        width:100%;
                        border:solid 1px #ced4da;
                        padding: 3px 6px;
                        line-height:28px;
                        span{
                            display:block;
                            float:left;
                            width:90%;
                        
                        }
                        &:hover{
                            cursor:pointer;
                        }

                        &:after{
                            content: '';
                            height:30px;
                            width:30px;
                            border-radius:15px;
                            float:left;
                        }
                        
                    }

                    .in-progress{
                        &:after{
                           background: #FFA700;
                        }
                        
                    }

                    .on-hold{
                        &:after{
                            background: #ef4e17;
                         }
                    }
                    .scheduled{
                        &:after{
                            border:solid 1px #000;
                         }
                    }

                    .status-delayed{
                        &:after{
                            background: #ff0000;
                         }
                    }

                    .status-completed{
                        &:after{
                            background: #22E000;
                         }
                    }
`


const Status = (props) => {
    const [showDropDown, setShowDropDown] = useState(0);

    const updateState = (value) => {
        props.updateStatus(value);
        setShowDropDown(0);
    }

    return (
        <SelectDropDown>
            <div className="row">
                <div className="col-12 pt-3">
                    <div className="form-group">
                        <label htmlFor="activityStatus">Status:</label>
                        {props.status === 'hold' ?
                            <div className="select-box on-hold" onClick={() => setShowDropDown(showDropDown === true ? false : true)}><span>On hold</span></div>
                            : props.status === 'completed' ?
                                <div className="select-box status-completed" onClick={() => setShowDropDown(showDropDown === true ? false : true)}><span>Completed</span></div>
                                : props.status === 'delayed' ?
                                    <div className="select-box status-delayed" onClick={() => setShowDropDown(showDropDown === true ? false : true)}><span>Delayed</span></div>

                                    : props.item && new Date(props.item.start) > new Date() ?
                                        <div className="select-box scheduled" onClick={() => setShowDropDown(showDropDown === true ? false : true)}><span>Scheduled</span></div>
                                        :
                                        <div className="select-box in-progress" onClick={() => setShowDropDown(showDropDown === true ? false : true)}><span>In progress</span></div>

                        }
                        {showDropDown ?
                            <div>
                                {props.item && new Date(props.item.start) > new Date() ?
                                    <div className="select-box scheduled" onClick={() => updateState('progress')}><span>Scheduled</span></div>
                                    : <div className="select-box in-progress" onClick={() => updateState('progress')}><span>In progress</span></div>
                                }
                                <div className="select-box on-hold" onClick={() => updateState('hold')}><span>On hold</span></div>
                                <div className="select-box status-delayed" onClick={() => updateState('delayed')}><span>Delayed</span></div>
                                <div className="select-box status-completed" onClick={() => updateState('completed')}><span>Completed</span></div>
                            </div>
                            : ''
                        }
                    </div>
                </div>
            </div>
        </SelectDropDown>
    );
}

export default Status;
